import { DiilHeader, DiilHeaderProps, Environment } from '@teliaee/diil-selfservice-components';
import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import React from 'react';
import { useStores } from '../stores/RootStore';
import { MainHeader } from 'telia-front-react';
import config from '../config';
import { languageSlug } from '../stores/LanguageStore';
import { GLOBAL_APP } from '../util/TranslateUtil';
import BreadcrumbContainer from './BreadcrumbContainer';

const HeaderContainer = observer((): React.JSX.Element => {
  const { translations } = React.useContext(TranslationsContext);
  const { ssoStore, languageStore, routeStore, menuStore, app } = useStores();

  const getPostLoginRedirectUrl = (): string => {
    if (app === 'super') {
      switch (languageStore.currentLanguage) {
        case 'en':
          return config.super.selfServiceUrlEn as string;
        case 'ru':
          return config.super.selfServiceUrlRu as string;
        case 'et':
        default:
          return config.super.selfServiceUrl as string;
      }
    }

    return config.diil.selfServiceUrl + languageSlug(languageStore.currentLanguage);
  };

  const diilHeaderProps: DiilHeaderProps = {
    diilGlobalTranslations: translations?.[GLOBAL_APP] || {},
    client: ssoStore.ssoClient,
    sso: {
      getLoginUrl: ssoStore.getLoginUrl.bind(ssoStore),
      isLoggedIn: ssoStore.loggedIn,
      setLoginParameters: ssoStore.setLoginParameters.bind(ssoStore),
      handleLogout: ssoStore.doLogout.bind(ssoStore),
      hardAuthRequired: ssoStore.hardAuthRequired,
      ssoFrameVisible: ssoStore.ssoFrameVisible,
      setModalClosed: ssoStore.closeSsoFrame.bind(ssoStore),
      setModalOpened: ssoStore.openSsoFrame.bind(ssoStore),
      person: ssoStore.person,
      customer: ssoStore.customer,
      dealer: ssoStore.dealer,
      isSsoLoaded: ssoStore.ssoLoaded
    },
    languageProps: {
      currentLanguage: languageStore.currentLanguage,
      setLanguage: languageStore.setLanguage.bind(languageStore)
    },
    isOnPath: routeStore.isOnCurrentPath.bind(languageStore),
    navigate: routeStore.navigate.bind(routeStore),
    environment: config.environment as Environment,
    app: 'public',
    brand: app,
    apiBaseUrl: config.apiBaseUrl,
    postLoginRedirectUrl: getPostLoginRedirectUrl(),
    initialMenuItems: menuStore.headerMenu,
    onChange: menuStore.updateHeaderState.bind(menuStore)
  };

  return (
    <MainHeader>
      <DiilHeader {...diilHeaderProps} />
      {app === 'diil' ? <BreadcrumbContainer /> : null}
    </MainHeader>
  );
});

export default HeaderContainer;
